import * as React from "react";
import BaseComponent from "components/BaseComponent";
import Logo from "components/Logo";
import InternalLink from "components/Navigation/InternalLink";
import ActionList from "components/ActionList/ActionList";
import {
    default as OverflowMenu, OverflowMenuDeleteItem, OverflowMenuNavLink,
    OverflowMenuDialogItem
} from "components/Menu/OverflowMenu";
import {EnvironmentResource} from "client/resources/environmentResource";
import {ChannelChip, EnvironmentChip} from "components/Chips/index";
import {ChannelResource} from "client/resources/channelResource";
import {TagResource} from "client/resources/tagResource";
import Tag from "components/Tag/Tag";
import FeatureToggle, {Feature} from "components/FeatureToggle/FeatureToggle";
import {deploymentPartNameClass} from "uiTestClasses";
import {DisabledChip} from "components/Chips/index";
import * as cn from "classnames";
import {baseSizeInPx} from "fontWeights";

type MenuItem = OverflowMenuNavLink | OverflowMenuDialogItem | OverflowMenuDeleteItem;

const styles  = require("./style.less");

interface DeploymentPartProps {
    name: string;
    logoUrl: string;
    index: string;
    children?: any;
    detailsUrl: string;
    menuItems?: Array<MenuItem | MenuItem[]>;
    mainAction?: any;
    environments?: EnvironmentResource[];
    excludedEnvironments?: EnvironmentResource[];
    channels?: ChannelResource[];
    tags?: TagResource[];
    isDisabled?: boolean;
}

class DeploymentPart extends BaseComponent<DeploymentPartProps, any> {
    render() {
        return <div className={styles.deploymentPart}>
            <div className={styles.actionSummary}>
                <div className={styles.logo}>
                    <Logo url={this.props.logoUrl} isDisabled={this.props.isDisabled} />
                </div>
                <div className={cn(styles.content, this.props.isDisabled ? styles.disabled : null)}>
                    <div className={styles.contentHeader}>
                        <span className={styles.index}>{this.props.index}</span>
                        <InternalLink to={this.props.detailsUrl} size={17 / baseSizeInPx}>
                            {this.props.isDisabled
                                ? <span className={`${deploymentPartNameClass}`}>{this.props.name} <DisabledChip /></span>
                                : <span className={deploymentPartNameClass}>{this.props.name}</span>}
                        </InternalLink>
                    </div>
                    <div className={styles.contentBody}>
                        {this.props.children}
                        <div>
                            {this.props.environments && this.props.environments.map(e => <EnvironmentChip key={e.Id} environmentName={e.Name} />)}
                            {this.props.excludedEnvironments &&
                                this.props.excludedEnvironments.map(e => <EnvironmentChip key={e.Id} environmentName={e.Name} isExcluded={true} />)}
                            {this.props.channels && this.props.channels.map(ch => <ChannelChip key={ch.Id} channelName={ch.Name} />)}
                            <FeatureToggle feature={Feature.MultiTenancy} enabled={true}>
                                {this.props.tags && this.props.tags.map(tag => <Tag
                                    key={tag.Id}
                                    description={tag.Description}
                                    tagName={tag.Name}
                                    tagColor={tag.Color}
                                />)}
                            </FeatureToggle>
                        </div>
                    </div>
                </div>
                <div className={styles.contextualActions}>
                    <ActionList actions={[
                        this.props.mainAction,
                        <OverflowMenu key={`${this.props.name}-overflow`} menuKey={`${this.props.name}-overflow`} menuItems={this.props.menuItems} />
                        ].filter(a => !!a)}/>
                </div>
            </div>
        </div>;
    }
}

export default DeploymentPart;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/areas/projects/components/DeploymentProcess/DeploymentPart.tsx